export default __webpack_public_path__ + "static/media/html-5.23639804.svg";